module.exports = __webpack_public_path__ + "img/lglogin.45e824ca.svg";